module.exports = "/images/disclosure-complete.png?5fbe8b0ebbc3bb1236c3c9f27115d483";